import { getStatusTone, type Tone } from '@shared/config/theme';

export interface PlatformHealthStatuses {
  database_status: string;
  redis_status: string;
  storage_status: string;
  agent_status: string;
}

export function getPlatformHealthTone(health: PlatformHealthStatuses): Tone {
  const tones = [
    health.database_status,
    health.redis_status,
    health.storage_status,
    health.agent_status,
  ].map(getStatusTone);

  if (tones.includes('danger')) return 'danger';
  if (tones.includes('warn')) return 'warn';
  if (tones.every((tone) => tone === 'ok')) return 'ok';
  return 'neutral';
}
